import React, { PropTypes } from 'react';
import classNames from '../../../../node_modules/classnames/index';
import styles from './TabBar.css';

export class TabBar extends React.Component {
  static propTypes = {
    options: PropTypes.array,
    onSelectOption: PropTypes.func,
    selected: PropTypes.any
  };

  handleItemClick = (option, e) => {
    e.stopPropagation();
    this.props.onSelectOption(option);
  }

  render () {
    const { options, selected } = this.props;
    const itemWidth = 100 / options.length;
    return (
      <div className={styles.container}>
        {options.map((option, index) => {
          const optionSelected = option.value === selected;
          return (
            <div
              key={index}
              className={classNames(styles.itemContainer, {[styles.selected]: optionSelected})}
              style={{width: itemWidth + '%'}}
              // eslint-disable-next-line
              onClick={(e) => this.handleItemClick(option, e)}>
              <span className={styles.itemText}>{option.label}</span>
            </div>
          );
        })}
      </div>
    );
  }
}

export default TabBar;



/** WEBPACK FOOTER **
 ** ./src/views/BaseElements/TabBar/TabBar.js
 **/